import { fetchWages } from "./data/dataFetching";
import { extractRequestBodyFromFilters, updateFilters } from "./data/dataParsing";

export async function updateWagesPageState(isMasterKeyValid, languageKey, salaryFilters, setSalaryFilters, setSalaryData) {
  const isInitialLoad = salaryFilters.isInitialLoad;
  const requestBody = extractRequestBodyFromFilters(salaryFilters, isInitialLoad);
  let wagesData = await fetchWages(languageKey, requestBody, (err) => console.log(err), isMasterKeyValid);
  let { context, reportData } = wagesData.data;
  let submitedFilters = context.filters;
  let nextAvailableFilters = context.nextAvailableFilters;
  let updatedFilters = await updateFilters(salaryFilters, submitedFilters, nextAvailableFilters, isInitialLoad, isMasterKeyValid, languageKey);
  setSalaryFilters(updatedFilters);
  setSalaryData(reportData);
}
